import {
    CREATE_ADMIN,
    EDIT_ADMIN_BY_ID,
    GET_ADMIN_BY_ID,
    GET_ADMINS,
    CREATE_CREDENTIAL,
    GET_CREDENTIAL,
    EDIT_CREDENTIAL_BY_ID,
    DELETE_CREDENTIAL_BY_ID,
    GET_EMPLOYMENT,
    CREATE_EMPLOYMENT,
    GET_PAY_CODE,
    CREATE_PAY_CODE,
    EDIT_EMPLOYMENT,
    CREATE_STAFF_SERVICE,
    GET_STAFF_SERVICE,
    DELETE_STAFF_SERVICE,
    GET_TIMESHEET,
    CREATE_TIMESHEET,
    GET_ALL_PAY_CODES,
    EDIT_TIMESHEET,
    GET_ALL_ADMINS,
    EDIT_PAY_CODE,
    IS_CLINICIAN,
    GET_TIMESHEET_BY_ID,
    CLEAR_ALL_PAY_CODES,
    CHANGE_ADMIN_STATUS,
    TERMINATE_PAY_CODE,
    CREATE_ADMIN_DETAILS,
    REMOVE_TIMESHEET_BY_ID,
    GET_FOUNDING_ALL_SERVICES,
    REINVITE_ADMIN,
    DELETE_EMPLOYMENT,
    UPLOAD_STAFF_AVATAR,
    GET_STAFF_FOR_APPT,
    GET_BASIC_ADMINS,
    GET_BASIC_ACTIVE_ADMINS,
    DELETE_STAFF_PAY_CODE,
    REMOVE_ADMIN_BY_ID,
    GET_STAFF_FS_SERVICE,
    EDIT_STAFF_PASSWORD,
    GET_STAFF_ASSIGNED_CLIENTS,
    ASSIGN_CLIENTS_TO_STAFF,
    EDIT_ASSIGNED_CLIENTS_FROM_STAFF,
    UNASSIGN_CLIENT_FORM_STAFF,
    CREATE_STAFF_SIGNATURE,
    DELETE_STAFF_SIGNATURE,
    CHANGE_TELEHEALTH_STATUS,
    ASSIGN_ZOOM_ACCOUNT,
    GET_STAFF_SUPERVISION_SUMMARY,
} from './admin.types';

/** Staff */

export const createAdmin = (body) => {
    return {
        type: CREATE_ADMIN,
        payload: { body },
    };
};
export const editStaffPassword = (body, id) => {
    return {
        type: EDIT_STAFF_PASSWORD,
        payload: { body, id },
    };
};
export const reinviteAdmin = (id) => {
    return {
        type: REINVITE_ADMIN,
        payload: { id },
    };
};

export const createAdminDetails = (id, body) => {
    return {
        type: CREATE_ADMIN_DETAILS,
        payload: { id, body },
    };
};

export const editAdminById = (body, id) => {
    return {
        type: EDIT_ADMIN_BY_ID,
        payload: { body, id },
    };
};
export const uploadAvatar = (id, body) => {
    return {
        type: UPLOAD_STAFF_AVATAR,
        payload: { id, body },
    };
};

export const getAdmins = (data, load) => {
    return {
        type: GET_ADMINS,
        payload: { data, load },
    };
};

export const getAllAdmins = (data) => {
    return {
        type: GET_ALL_ADMINS,
        payload: { data },
    };
};
export const getBasicAdmins = (params) => {
    return {
        type: GET_BASIC_ADMINS,
        payload: { params },
    };
};

export const getBasicActiveAdmins = (params) => {
    return {
        type: GET_BASIC_ACTIVE_ADMINS,
        payload: { params },
    };
};

export const getAdminById = (adminId, load) => {
    return {
        type: GET_ADMIN_BY_ID,
        payload: { adminId, load },
    };
};
export const removeAdminById = () => {
    return {
        type: REMOVE_ADMIN_BY_ID,
    };
};

export const changeAdminStatus = (id, params) => {
    return {
        type: CHANGE_ADMIN_STATUS,
        payload: { id, params },
    };
};
export const changeTelehealthStatus = (id, params) => {
    return {
        type: CHANGE_TELEHEALTH_STATUS,
        payload: { id, params },
    };
};
export const assignZoomAccount = (staffId, body) => {
    return {
        type: ASSIGN_ZOOM_ACCOUNT,
        payload: { staffId, body },
    };
};

/** End */

/** Staff Credentials */

export const createCredential = (body) => {
    return {
        type: CREATE_CREDENTIAL,
        payload: { body },
    };
};

export const getCredential = (credentialId, data, load) => {
    return {
        type: GET_CREDENTIAL,
        payload: { credentialId, data, load },
    };
};

export const editCredentialById = (body, id, credentialId) => {
    return {
        type: EDIT_CREDENTIAL_BY_ID,
        payload: { body, id, credentialId },
    };
};

export const deleteCredentialById = (id, credentialId) => {
    return {
        type: DELETE_CREDENTIAL_BY_ID,
        payload: { id, credentialId },
    };
};

/** End */

/** Staff Employment */

export const getEmployment = (id) => {
    return {
        type: GET_EMPLOYMENT,
        payload: { id },
    };
};

export const createEmployment = (body, id) => {
    return {
        type: CREATE_EMPLOYMENT,
        payload: { body, id },
    };
};

export const editEmployment = (body, id, staffId) => {
    return {
        type: EDIT_EMPLOYMENT,
        payload: { body, id, staffId },
    };
};

export const deleteEmployment = (id, staffId) => {
    return {
        type: DELETE_EMPLOYMENT,
        payload: { id, staffId },
    };
};

/** End */

/** Staff PayCode */

export const getPayCode = (id, params, load) => {
    return {
        type: GET_PAY_CODE,
        payload: { id, params, load },
    };
};

export const createPayCode = (body, id) => {
    return {
        type: CREATE_PAY_CODE,
        payload: { body, id },
    };
};

export const editPayCode = (body, id, payCodeId, requestParams) => {
    return {
        type: EDIT_PAY_CODE,
        payload: { body, id, payCodeId, requestParams },
    };
};

export const deletePayCode = (payCodeId) => {
    return {
        type: DELETE_STAFF_PAY_CODE,
        payload: { payCodeId },
    };
};

export const terminatePayCode = (payCodeId, id) => {
    return {
        type: TERMINATE_PAY_CODE,
        payload: { payCodeId, id },
    };
};

export const getAllPayCodes = (id) => {
    return {
        type: GET_ALL_PAY_CODES,
        payload: { id },
    };
};

export const clearAllPayCodes = () => {
    return {
        type: CLEAR_ALL_PAY_CODES,
    };
};

/** End */

/** Staff Service */

export const getStaffFsServices = () => {
    return {
        type: GET_STAFF_FS_SERVICE,
    };
};
export const getStaffService = (id) => {
    return {
        type: GET_STAFF_SERVICE,
        payload: { id },
    };
};

export const createStaffService = (id, serviceId) => {
    return {
        type: CREATE_STAFF_SERVICE,
        payload: { id, serviceId },
    };
};

export const deleteStaffService = (id, serviceId) => {
    return {
        type: DELETE_STAFF_SERVICE,
        payload: { id, serviceId },
    };
};

/** End */

/** Staff Timesheet */

export const getTimesheet = (id, data, load) => {
    return {
        type: GET_TIMESHEET,
        payload: { id, data, load },
    };
};
export const getTimesheetById = (id) => {
    return {
        type: GET_TIMESHEET_BY_ID,
        payload: { id },
    };
};
export const removeTimesheetById = () => {
    return {
        type: REMOVE_TIMESHEET_BY_ID,
    };
};

export const createTimesheet = (body) => {
    return {
        type: CREATE_TIMESHEET,
        payload: { body },
    };
};

export const editTimesheet = (body, id) => {
    return {
        type: EDIT_TIMESHEET,
        payload: { body, id },
    };
};

/** End */

export const isClinician = (id, isClinical) => {
    return {
        type: IS_CLINICIAN,
        payload: { id, isClinical },
    };
};

export const getStaffForAppt = () => {
    return {
        type: GET_STAFF_FOR_APPT,
    };
};

/** Staff Assignment */
export const assignClientToStaff = (body, staffId) => {
    return {
        type: ASSIGN_CLIENTS_TO_STAFF,
        payload: { body, staffId },
    };
};
export const unAssignClientToStaff = (id, staffId) => {
    return {
        type: UNASSIGN_CLIENT_FORM_STAFF,
        payload: { id, staffId },
    };
};
export const editAssignClientFromStaff = (id, body, staffId) => {
    return {
        type: EDIT_ASSIGNED_CLIENTS_FROM_STAFF,
        payload: { id, body, staffId },
    };
};
export const getAssignedStaffClients = (staffId) => {
    return {
        type: GET_STAFF_ASSIGNED_CLIENTS,
        payload: { staffId },
    };
};
/** End */

/** Staff Signature */

export const createStaffSignature = (body, staffId) => {
    return {
        type: CREATE_STAFF_SIGNATURE,
        payload: { body, staffId },
    };
};

export const deleteStaffSignature = (params, staffId) => {
    return {
        type: DELETE_STAFF_SIGNATURE,
        payload: { params, staffId },
    };
};

/** End */

/** Staff Supervision Summary */

export const getStaffSupervisionSummary = (params) => {
    return {
        type: GET_STAFF_SUPERVISION_SUMMARY,
        payload: { params },
    };
};

/** End */
